import { ReactElement } from "react";
import UserMessages from "./UserMessages";
import { IUserInfo } from "../../messages/IAppInfo";
import DashboardStatistics from "./DashboardStatistics";

export default function Dashboard(props: {
    userInfo: IUserInfo;
}): ReactElement {
    document.title = "Cydrill Sergeant";
    return (
        <>
            <div className="cy__dashboard">
                <DashboardStatistics userInfo={props.userInfo} />
                <UserMessages userInfo={props.userInfo} />
            </div>
        </>
    );
}